module.exports = __webpack_public_path__ + "static/media/image (12).68c4b013.jpg";